import { makeStyles } from '@material-ui/core';

const useBaseStyles = makeStyles((theme) => ({
  root: {
    '&.DayPicker': {
      position: 'relative',
      display: 'flex',
      backgroundColor: theme.palette.common.white,
      boxShadow: theme.shadow.componentDark,
      border: `solid 1px ${theme.colors.greyE8}`,
      zIndex: 2,
      height: 304,
    },
    '& .DayPicker': {
      '&-wrapper': {
        padding: 20,
      },

      '&-Caption': {
        ...theme.flex.center,
        ...theme.typography.h5,
        marginBottom: 18,
        height: 32,
        textAlign: 'center',
        color: theme.colors.dark,
      },

      '&-WeekdaysRow': {
        display: 'flex',
        justifyContent: 'space-evenly',
      },

      '&-Weekday': {
        ...theme.typography.dropdown,
        width: 32,
        height: 20,
        textAlign: 'center',
        color: theme.colors.grey99,

        '& abbr[title]': {
          borderBottom: 'none',
          textDecoration: 'none',
        },
      },

      '&-Week': {
        display: 'flex',
        justifyContent: 'space-evenly',
      },

      '&-Day': {
        ...theme.flex.center,
        ...theme.typography.body1,
        position: 'relative',
        width: 32,
        height: 32,
        color: theme.colors.dark,
        cursor: 'pointer',

        '&--selected:not(.DayPicker-Day--outside)': {
          ...theme.typography.button,
          backgroundColor: theme.colors.grey66,
          color: theme.palette.common.white,
          borderRadius: theme.borderRadius.small,
          transition: '0.3s',
          '&:hover': {
            backgroundColor: theme.colors.grey99,
          },
        },

        '&--disabled': {
          color: theme.colors.greyCc,
        },

        '&--today:not(.DayPicker-Day--outside)::after': {
          content: "''",
          position: 'absolute',
          bottom: 0,
          width: 4,
          height: 4,
          borderRadius: '50%',
          backgroundColor: theme.colors.brandIcon,
          left: '50%',
          transform: 'translateX(-50%)',
        },

        '&:not(.DayPicker-Day--selected):not(.DayPicker-Day--outside):not(.DayPicker-Day--disabled):hover': {
          backgroundColor: theme.colors.greyFa,
          borderRadius: theme.borderRadius.small,
        },
      },
    },
  },
}));

export default useBaseStyles;
